// Utils
import {
  IpsFromEntity,
  IpsFromEvent,
  FullSARFilingResponse,
  SARAttachmentResponse,
  UpdateSarResponse,
  ValidateSarResponse,
  SarNarrativeTemplate,
  ArchiveSarResponse,
  ShortSARFilingResponse,
} from 'app/modules/fincenSAR/responses';
import {
  UpdateSarPayload,
  SarXlsxCsvExportPayload,
  SarSubmitPayload,
  DuplicateSarPayload,
  ArchivePayload,
  ChangeSarQueuePayload,
  EditSarReviewerPayload,
} from 'app/modules/fincenSAR/requests';
import {
  destroy,
  get,
  post,
  put,
  upload,
  downloadFile,
} from 'app/shared/utils/fetchr';
import { FilingNarrativeTemplateType } from 'app/modules/narrativeTemplates/models';

export const updateSar = (
  id: string,
  payload: UpdateSarPayload,
): Promise<UpdateSarResponse> => {
  return put(`/sars/${id}/edit`, payload);
};

export const validateSar = (id: string): Promise<ValidateSarResponse> => {
  return post(`/sars/${id}/validate`);
};

export const ipsFromEntity = (sarId: string): Promise<IpsFromEntity> => {
  return post(`/sars/${sarId}/entities/import-ips`);
};

export const ipsFromEvent = (sarId: string): Promise<IpsFromEvent> => {
  return post(`/sars/${sarId}/events/import-ips`);
};

export const uploadAttachment = (
  id: string,
  file: File,
): Promise<SARAttachmentResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  return upload(`/sars/${id}/attachment`, formData);
};

export const deleteAttachment = (
  id: string,
): Promise<Record<string, never>> => {
  return destroy(`/sars/${id}/attachment`);
};

export const downloadAttachment = (id: number, fileName: string) => {
  return downloadFile(`/attachments/download/${id}`, fileName);
};

export const getNarrativeTemplates = (): Promise<SarNarrativeTemplate[]> => {
  // DEPRECATION (P2-T1): old route `/sars/narrative/list` to be removed after migration.
  return get('/narrative-templates/filings/list', [
    {
      key: 'template_type',
      value: FilingNarrativeTemplateType.FINCEN_SAR,
    },
  ]);
};

export const exportXlsxOrCsv = (
  payload: SarXlsxCsvExportPayload,
): Promise<Record<string, never>> => {
  return post('/sars/single-email-xlsx', payload);
};

export const archiveSar = (
  payload: ArchivePayload,
): Promise<ArchiveSarResponse> => {
  return post('/sars/archive', payload);
};

export const returnToEdit = (
  sarId: number,
): Promise<ShortSARFilingResponse> => {
  return post(`/sars/${sarId}/unlock`);
};

export const readyForReview = (
  sarId: number,
): Promise<ShortSARFilingResponse> => {
  return post(`/sars/${sarId}/lock`);
};

export const submitSar = (
  payload: SarSubmitPayload,
): Promise<FullSARFilingResponse> => {
  return post(`/sars/${payload.id}/submit`, payload);
};

export const duplicateSar = (
  payload: DuplicateSarPayload,
  useCacheEndpoint: boolean = false,
): Promise<FullSARFilingResponse> => {
  if (useCacheEndpoint) {
    return post('/sars/cached/duplicate', payload);
  }
  return post('/sars/duplicate', payload);
};

export const changeSarQueue = (
  payload: ChangeSarQueuePayload,
): Promise<{ filings: ShortSARFilingResponse[] }> => {
  return post('/sars/requeue', payload);
};

export const editSarReviewerApi = (
  id: number,
  payload: EditSarReviewerPayload,
): Promise<ShortSARFilingResponse> => {
  return put(`/sars/${id}/edit`, payload);
};
